import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';

// Same Firebase project as the rest of the Lushin platform — auth is shared with
// admin-portal and frontend, and it MUST match backend-tenant's
// FIREBASE_PROJECT_ID. A token minted by any other project is rejected there, so
// a wrong value here fails at the first authenticated request, not at login.
const firebaseConfig = {
  apiKey: 'AIzaSyDya2iIB-_C63FD30tiu5S3HI53bXI0nVs',
  authDomain: 'lushin-apexia.firebaseapp.com',
  projectId: 'lushin-apexia',
  storageBucket: 'lushin-apexia.firebasestorage.app',
  messagingSenderId: '154139921806',
  appId: '1:154139921806:web:a0345df7ffa14fea4de8df'
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  // Non-fatal: auth still works, just won't persist across reloads.
  console.error('[Firebase] Failed to set auth persistence:', error);
});

export default app;
